import { useAuth } from "@/auth";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { isSessionRejected } from "@/common/utils/graphql-error.utils";
import { QueryHookOptions, useQuery } from "@apollo/client";
import meGql from "@whoppah/apollo/query/me.graphql";
import { MeQuery, MeQueryVariables } from "@whoppah/apollo/schema";

// ponytail: module-level, so identify fires once per user per page load, not
// once per `useMe` consumer. The Statsig user is synced by `StatsigUserSync`.
let identifiedUserId: string | undefined;

// TODO: Move this hook and rework it
const useMe = (options?: QueryHookOptions<MeQuery, MeQueryVariables>) => {
  const { token, reset, setUserId } = useAuth();

  return useQuery(meGql, {
    ...options,
    skip: !token,
    onCompleted: data => {
      setUserId(data.me?.id);

      if (data.me && data.me.id !== identifiedUserId) {
        identifiedUserId = data.me.id;
        analyticsService.identify(data.me);
      }
    },
    onError: error => {
      // Only a rejected token ends the session. Resetting on any error logged
      // users out whenever Me failed for another reason - most often a page
      // navigation aborting the in-flight request.
      if (token && isSessionRejected(error)) {
        reset();
      }
    },
  });
};

export default useMe;
